import { API_BASE_URL, API_FETCH_EXAM_RESULT_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


interface examResult {
    [key: string]: boolean[];
}

export interface getFetchExamResultResponse {
    results: (examResult | null)[];
}

async function executeGetFetchExamResultWithToken(accessToken: string | null, uuids: string[]): Promise<getFetchExamResultResponse> {
    return axios
        .post(
            API_BASE_URL + API_FETCH_EXAM_RESULT_PATH,
            {
                uuids: uuids,
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else if (error.response && error.response.status === 404) {
                console.log("result not found");
            } else if (error.response && error.response.status === 400) {
                console.log("Not allowed to access");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetFetchExamResultWithToken(accessToken: string | null, uuids: string[]): Promise<getFetchExamResultResponse> {

    return executeGetFetchExamResultWithToken(accessToken, uuids)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetFetchExamResultWithToken(accessToken, uuids);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
